import { render, staticRenderFns } from "./RichTextHeading.vue?vue&type=template&id=20f439fc&"
import script from "./RichTextHeading.vue?vue&type=script&lang=js&"
export * from "./RichTextHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports